import { IRoleEnum } from "@interfaces";
import { createRoute } from "@routes/utils";

import { incomeRoutesObj } from "./path";

import type { IRouteMetadataObj } from "@routes/types";

const permission = [IRoleEnum.SUPER_ADMIN];

const incomeRouteMetadata: IRouteMetadataObj<typeof incomeRoutesObj> = {
  list: {
    title: "financialManagement.index.title",
    description: "empty",
    lazy: () => import("@/pages/financialManagement/incomeDebt/table/page"),
    mode: "index",
    type: "main",
    icon: "ReceiptLine",
    breadcrumbs: [],
    permission,
  },
};

export const incomeRoutes = createRoute<typeof incomeRoutesObj>(
  incomeRoutesObj,
  incomeRouteMetadata,
);
